export default __webpack_public_path__ + "static/media/Bottom.2954165c.dwg";